<div class="modal__header">
        <div class="modal__title">
            SHARE YOUR LINK
        </div>
        <div class="modal__close" (click)="popup.close();">
            <i class="fas fa-times"></i>
        </div>
    </div>
    
    <div class="modal__content">
        <div class="row">
            <div class="col-xs-12">
                <label class="control-label">Borrower link to upload documents</label>
                <div class="input-group">
                    <input id="portalLink" type="text" [(ngModel)]="portalLink" class="form-control" placeholder="Personal link to Portal" readonly>
                    <div class="input-group-btn">
                        <button class="btn btn-default" type="button" (click)="copyToClipboard()">Copy</button>
                    </div>
                </div>
            </div>
        </div>
    
        <div class="row">
            <p class="center-margin">OR</p>
        </div>
    
        <div class="row">
            <p class="mail-text" (click)='sendEmail()'>Send By Email<i class="fas fa-envelope mail-icon"></i></p>
        </div>

        <div class="row">
            <p class="note">NOTE: For security purposes this link expires after 14 days</p>
        </div>
   </div>
    
    <div class="modal__footer">
        <button type="reset" class="btn btn-link" (click)="popup.close();">Close</button>

    </div>
    